module.exports = __webpack_public_path__ + "static/media/caution4.4fb14996.png";